import { Col, Container, Row } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import { ConcursoProps } from '../../../providers/ConcursoProvider';
import { jurisSelector } from './gestionConcursoSlice';

const MainContainer = styled(Container)`
  border: 1px solid lightgray;
  padding: 15px;
  border-radius: 10px;
`;

const Title = styled.span`
  font-weight: bold;
  margin-right: 8px;
`;

type Props = { concurso: ConcursoProps };
const ConcursoData = ({ concurso }: Props) => {
  const jurisdicciones = useSelector(jurisSelector);
  const jurisData = jurisdicciones.find(
    (el: any) => el.idJurisdiccion === concurso.organismo.idJurisdiccion,
  );

  return (
    <MainContainer>
      <Row>
        <Col>
          <Title>ID:</Title>
          <span>{concurso.idLlamadoConcurso}</span>
        </Col>
        <Col>
          <Title>Tipo de convocatoria:</Title>
          <span>{concurso.tipoConcurso.nombre}</span>
        </Col>
      </Row>
      <Row>
        <Col>
          <Title>Jurisdicción:</Title>
          <span>{jurisData && jurisData.nombre}</span>
        </Col>
        <Col>
          <Title>Organismo:</Title>
          <span>{concurso.organismo.nombre}</span>
        </Col>
      </Row>
      <Row>
        <Col>
          <Title>Cantidad de cargos:</Title>
          <span>{concurso.cantidadCargoReserva + concurso.cantidadCargoSinReserva}</span>
        </Col>
        <Col></Col>
      </Row>
    </MainContainer>
  );
};

export default ConcursoData;
